import { Fragment } from 'react';
import { BuyDialogType } from './BuyDialogType';

export const BuyDialogTypeSelector = ({ types, value, onChange }) => (
  <div className="flex justify-center mb-2.5 flex-wrap">
    {types.map(({ name }) => (
      <Fragment key={name}>
        {name !== '3xl' && (
          <BuyDialogType
            name={name}
            checked={value === name}
            onChange={onChange}
          />
        )}
      </Fragment>
    ))}
  </div>
);
